import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useClientPortalPaths } from "../../hooks/useClientPortalBase";
import { getCourseReport, exportReportCsv } from "../../api/clientAnalyticsApi";
import ClientAnalyticsDateRange from "../../components/clientPortal/ClientAnalyticsDateRange";
import { ClientPortalError, ClientPortalLoading } from "../../components/clientPortal/ClientPortalStates";
import { buildAnalyticsQuery } from "../../utils/clientAnalyticsQuery";
import { formatClientDate } from "../../utils/clientPortalFormat";

const ClientCourseReportPage = () => {
  const { clientViewId } = useParams();
  const [preset, setPreset] = useState("30d");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const paths = useClientPortalPaths();

  useEffect(() => {
    setLoading(true);
    getCourseReport(clientViewId, buildAnalyticsQuery({ preset, dateFrom, dateTo }))
      .then((body) => setRows(body.courses || []))
      .catch((e) => setErrorMessage(e.message || "Unable to load report."))
      .finally(() => setLoading(false));
  }, [clientViewId, preset, dateFrom, dateTo]);

  return (
    <>
      <section className="panel-card">
        <p className="eyebrow">
          <Link to={paths.viewSection(clientViewId, "reports")}>Reports</Link> / Courses
        </p>
        <div className="client-portal-section-header">
          <h2>Course Interest Report</h2>
          <button
            type="button"
            className="midpoint-share-button secondary"
            onClick={() =>
              exportReportCsv(clientViewId, {
                ...buildAnalyticsQuery({ preset, dateFrom, dateTo }),
                reportType: "courses",
              })
            }
          >
            Export CSV
          </button>
        </div>
        <ClientAnalyticsDateRange
          preset={preset}
          dateFrom={dateFrom}
          dateTo={dateTo}
          onChange={({ preset: p, dateFrom: f, dateTo: t }) => {
            if (p != null) setPreset(p);
            if (f != null) setDateFrom(f);
            if (t != null) setDateTo(t);
          }}
        />
      </section>
      {loading ? <ClientPortalLoading /> : null}
      {errorMessage ? <ClientPortalError message={errorMessage} /> : null}
      {!loading && (
        <div className="panel-card">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Course</th>
                <th>Community</th>
                <th>Status</th>
                <th>Leads</th>
                <th>New</th>
                <th>Won</th>
                <th>Last inquiry</th>
                <th>Type</th>
                <th>Holes</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.courseId}>
                  <td>{r.courseName}</td>
                  <td>{r.communityName || "—"}</td>
                  <td>{r.displayStatus}</td>
                  <td>{r.opportunityCount}</td>
                  <td>{r.newOpportunities}</td>
                  <td>{r.closedWonOpportunities}</td>
                  <td>{r.lastOpportunityDate ? formatClientDate(r.lastOpportunityDate) : "—"}</td>
                  <td>{r.publicPrivateType || "—"}</td>
                  <td>{r.numberOfHoles ?? "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default ClientCourseReportPage;
